import { isTRPCClientError } from '@trpc/client';

/** How long a query waits before its single retry after a network failure. */
export const QUERY_RETRY_DELAY_MS = 1000;

/**
 * Whether a query error means the request never got an HTTP response, as when the connection drops.
 * Any response, including a non-JSON error page, is not a network failure.
 *
 * @param error - The error a query threw.
 * @returns True when the underlying `fetch` rejected.
 */
export function isNetworkFailure(error: unknown): boolean {
	return isTRPCClientError(error) && error.cause instanceof TypeError;
}

/**
 * Retry policy for queries: one retry after a network failure, none otherwise.
 *
 * @param failureCount - How many retries have already been made.
 * @param error - The error the latest attempt threw.
 * @returns True when the query should be retried.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
	return failureCount < 1 && isNetworkFailure(error);
}
